import { TrendingUp, TrendingDown } from "lucide-react";

export const cls = "w-full px-2 py-1.5 text-xs border border-slate-300 rounded-md bg-white focus:border-amber-500 outline-none";
export const pct = (n, o) => (o ? Math.round(((n - o) / o) * 10000) / 100 : null);
export const Pct = ({ v }) => v === null || v === undefined || Number.isNaN(v) ? null : (
  <span className={`inline-flex items-center gap-0.5 font-semibold ${v > 0 ? "text-emerald-700" : v < 0 ? "text-red-700" : "text-slate-500"}`}>{v > 0 ? <TrendingUp className="w-3 h-3" /> : v < 0 ? <TrendingDown className="w-3 h-3" /> : null}{v > 0 ? "+" : ""}{v}%</span>
);
export const today = () => new Date().toISOString().slice(0, 10);
export const addDays = (iso, n) => { const d = new Date(iso + "T00:00:00"); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
